import { SerializationMode } from '../serialization/serialization-mode';

export class ObjectSerialization {
  version: number;
  mode: SerializationMode;
  isCompressed: boolean;
  objectType: string;
  object: string;
}
